;(function(){
  'use strict';
  if(window.ffRevealDone)return;
  window.ffRevealDone=true;

  var st=document.createElement('style');
  st.id='ff-reveal-styles';
  st.textContent=[
    '.ff-js-anims .ff-rv-s{opacity:0;transform:translateY(28px);transition:opacity .7s cubic-bezier(.4,0,.2,1),transform .7s cubic-bezier(.4,0,.2,1);}',
    '.ff-js-anims .ff-rv-s.ff-in{opacity:1!important;transform:none!important;}',
    '.ff-js-anims .ff-rv-c{opacity:0;transform:translateY(18px);transition:opacity .55s ease,transform .55s ease;}',
    '.ff-js-anims .ff-rv-c.ff-in{opacity:1!important;transform:none!important;}',
    '.ff-js-anims .ff-rv-h{opacity:0;transform:translateX(-12px);transition:opacity .6s ease,transform .6s ease;}',
    '.ff-js-anims .ff-rv-h.ff-in{opacity:1!important;transform:none!important;}',
    '@media(prefers-reduced-motion:reduce){.ff-js-anims .ff-rv-s,.ff-js-anims .ff-rv-c,.ff-js-anims .ff-rv-h{opacity:1!important;transform:none!important;transition:none!important;}}'
  ].join('');
  document.head.appendChild(st);

  if(!('IntersectionObserver' in window))return;

  var SECS=[
    /* Home */
    '.ff-cats2','.ff-prod-row','.ff-editorial',
    '.ff-trust','.ff-occasion','.ff-social','.ff-email-capture',
    /* Collection */
    '.ff-cl__intro','.ff-cl__main',
    /* Wishlist */
    '.ff-wp',
    /* FAQ */
    '.ff-faq__body',
    /* Returns */
    '.ff-ret__body',
    /* Shipping */
    '.ff-ship__body',
    /* About */
    '.ff-about__mission','.ff-about__pillars','.ff-about__stats','.ff-about__story','.ff-about__cta',
    /* Contact */
    '.ff-con__body',
    /* Blog list */
    '.ff-bl__body',
    /* Article */
    '.ff-art__cover','.ff-art__layout','.ff-art__back'
  ];

  var KIDS=[
    ['.ff-cats2__scroll',       '.ff-cats2__tile'],
    ['.ff-prod-row__grid',      '.ff-prod-row__item'],
    ['.ff-occasion__grid',     '.ff-occasion__tile'],
    ['.ff-social__grid',       '.ff-social__item'],
    ['.ff-trust__grid',        '.ff-trust__item'],
    ['.ff-cl__grid',           '.ff-cl__grid > li'],
    ['.ff-wp__grid',           '.ff-wp__item'],
    ['.ff-faq__body',          '.ff-faq__category'],
    ['.ff-ret__badges',        '.ff-ret__badge'],
    ['.ff-ret__body',          '.ff-ret__section'],
    ['.ff-ret__steps',         '.ff-ret__step'],
    ['.ff-ret__specials',      '.ff-ret__special'],
    ['.ff-ship__badges',       '.ff-ship__badge'],
    ['.ff-ship__body',         '.ff-ship__section'],
    ['.ff-ship__times',        '.ff-ship__time-card'],
    ['.ff-about__pillars-grid','.ff-about__pillar'],
    ['.ff-about__stats',       '.ff-about__stat'],
    ['.ff-con__cards',         '.ff-con__card'],
    /* Blog list */
    ['.ff-bl__grid',           '.ff-bl__grid > li'],
    /* Article sidebar */
    ['.ff-art__sidebar',       '.ff-art__about-card,.ff-art__related-list']
  ];

  var HEADS=[
    ['.ff-prod-row__header',    '.ff-prod-row__eyebrow,.ff-prod-row__heading'],
    ['.ff-occasion__header',   '.ff-occasion__eyebrow,.ff-occasion__heading'],
    ['.ff-about__mission-content','.ff-about__mission-h'],
    ['.ff-about__story-inner', '.ff-about__story-h'],
    /* Blog featured */
    ['.ff-bl__featured-content','.ff-bl__featured-h']
  ];

  var gid=0;

  function addClasses(){
    SECS.forEach(function(sel){
      document.querySelectorAll(sel).forEach(function(el){
        if(el.closest('.ff-hero-section,.ff-hero2,.ff-about__hero,.ff-con__hero,.ff-ret__hero,.ff-ship__hero,.ff-faq__hero,.ff-bl__hero,.ff-art__hero'))return;
        el.classList.add('ff-rv-s');
      });
    });
    KIDS.forEach(function(pair){
      document.querySelectorAll(pair[0]).forEach(function(c){
        var id='rg'+(gid++);
        c.querySelectorAll(pair[1]).forEach(function(child){
          child.classList.add('ff-rv-c');
          child.dataset.rvg=id;
        });
      });
    });
    HEADS.forEach(function(pair){
      document.querySelectorAll(pair[0]).forEach(function(c){
        c.querySelectorAll(pair[1]).forEach(function(h){
          h.classList.add('ff-rv-h');
        });
      });
    });
  }

  function setupObservers(){
    var sio=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(!e.isIntersecting)return;
        e.target.classList.add('ff-in');
        sio.unobserve(e.target);
      });
    },{threshold:0.06,rootMargin:'0px 0px -32px 0px'});

    var cio=new IntersectionObserver(function(entries){
      var groups={};
      entries.forEach(function(e){
        if(!e.isIntersecting)return;
        var g=e.target.dataset.rvg||'g';
        if(!groups[g])groups[g]=[];
        groups[g].push(e.target);
        cio.unobserve(e.target);
      });
      Object.keys(groups).forEach(function(k){
        groups[k].forEach(function(el,i){
          setTimeout(function(){el.classList.add('ff-in');},i*80);
        });
      });
    },{threshold:0.04,rootMargin:'0px 0px -16px 0px'});

    var hio=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(!e.isIntersecting)return;
        e.target.classList.add('ff-in');
        hio.unobserve(e.target);
      });
    },{threshold:0.1});

    document.querySelectorAll('.ff-rv-s').forEach(function(el){sio.observe(el);});
    document.querySelectorAll('.ff-rv-c').forEach(function(el){cio.observe(el);});
    document.querySelectorAll('.ff-rv-h').forEach(function(el){hio.observe(el);});
  }

  function safetyRelease(){
    document.querySelectorAll('.ff-rv-s:not(.ff-in),.ff-rv-c:not(.ff-in),.ff-rv-h:not(.ff-in)').forEach(function(el){
      el.classList.add('ff-in');
    });
  }

  function init(){
    document.documentElement.classList.add('ff-js-anims');
    addClasses();
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        setupObservers();
        setTimeout(safetyRelease,2500);
      });
    });
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init);
  } else {init();}

  document.addEventListener('shopify:section:load',function(){
    document.querySelectorAll('.ff-rv-s,.ff-rv-c,.ff-rv-h').forEach(function(el){
      el.classList.add('ff-in');
    });
  });

})();
